import { useContext } from "react"

import { findGlowColor } from "../helpers"
import { colors } from "../helpers/constants"
import AppContext from "./AppConext"

export const useColor = (name) => {
  const { hovered, menuHovered, selected } = useContext(AppContext)
  const initColor = colors[name]

  let color = initColor
  if ([hovered, menuHovered, selected].includes(name)) {
    color = findGlowColor(initColor)
  }

  return { color }
}
